module.exports = __webpack_public_path__ + "img/invoice-de-male-banner-rp.74ecb3a6.png";